<template>
    <div :class="{ collapsed: isSelected && isFavorite }">
        <div
            v-if="educationId > 0"
            class="favorite-button"
            @mouseover="isHovered = true"
            @mouseleave="leaveHover"
            @click.prevent="triggerSelected"
        >
            <a href="#" @click.prevent="toggleIsFavorite">
                <i
                    class=" fa-heart"
                    :class="[favoriteIconClass, hoverIconClass]"
                ></i>
            </a>
        </div>
        <div class="favorite-button__info">
            <span v-if="isHovered && !isFavorite">
                {{ buttonHover }}
            </span>
            <span v-if="isSelected && isFavorite">
                <a :href="buttonLink">{{ buttonSelected }}</a>
            </span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        educationId: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            isFavorite: false,
            isHovered: false,
            isSelected: false,
            buttonHover: '',
            buttonSelected: '',
            buttonLink: ''
        };
    },

    computed: {
        favoriteIconClass() {
            return this.isFavorite ? 'fas' : 'far';
        },
        hoverIconClass() {
            return this.isHovered ? 'fas' : '';
        }
    },

    watch: {
        isFavorite(val) {
            if (val) {
                this.$store.commit('addFavorite', this.educationId);
            } else {
                this.$store.commit('removeFavorite', this.educationId);
            }
        }
    },

    created() {
        this.isFavorite = this.$store.getters.getFavoriteById(this.educationId);
        this.getButtonText();
    },

    methods: {
        leaveHover() {
            setTimeout(() => {
                this.isHovered = false;
            }, 1225);
        },
        triggerSelected() {
            setTimeout(() => {
                this.isSelected = true;
            }, 1225);
        },
        toggleIsFavorite() {
            this.isFavorite = !this.isFavorite;
        },
        getButtonText() {
            axios({
                method: 'get',
                url: '/api/EducationApi/GetFavoriteButtonTexts'
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.buttonHover = response.data.buttonHover;
                    this.buttonSelected = response.data.buttonSelected;
                    this.buttonLink = response.data.buttonLink;

                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.favorite-button {
    position: absolute;
    color: $color-white;
    right: 20px;
    top: 6px;
    font-size: 2rem;
    z-index: 10;

    &:hover {
        a {
            color: $color-orange;
        }
    }

    a {
        color: $color-white;
    }

    .block-header--dark & {
        a {
            color: $color-black;
        }
    }

    @include media-breakpoint-up(md) {
        right: 40px;
        top: 15px;
        font-size: 3.5rem;
    }
}

.fas {
    font-weight: 900;
}

.favorite-button__info {
    position: absolute;
    right: 74px;
    top: 42px;
    background-color: $color-white;
    border-radius: 23.5px 0 0 23.5px;
    z-index: 5;
    max-width: 0;
    transition: 1.225s max-width ease-in-out;
    overflow: hidden;

    span {
        color: $color-orange;
        padding: 5px 30px 5px 15px;
        display: block;
        white-space: nowrap;
    }

    a {
        color: $color-orange;
        text-decoration: underline;
    }
}

.favorite-button__info span:empty {
    display: none;
}

.favorite-button:hover + .favorite-button__info,
.collapsed .favorite-button__info {
    max-width: 100%;
}
</style>
